var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gb-l-languages-container"},_vm._l((_vm.languages),function(l){return _c('div',{key:l.locale,class:['gb-l-flag', 'flag:' + l.flag],on:{"click":function($event){return _vm.changeLanguage(l.locale)}}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }